import { PiteasBuy } from '@app/collections/piteas-buy'
import Head from 'next/head'

export default function Buy() {
  return (
    <>
      <Head>
        <title>Buy - Coast</title>
      </Head>
      <PiteasBuy />
    </>
  )
}
